export const LOAD_SERVICE_REQUEST_APPROVALS = "LOAD_SERVICE_REQUEST_APPROVALS"
export const loadServiceRequestApprovalsAction = pagination => ({
   type: LOAD_SERVICE_REQUEST_APPROVALS,
   payload: pagination
})